var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "0 0 7 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.69259987,1.96234533 L4.02579072,3.02304533 L4.02579072,2.20494714 C4.02579072,1.97830471 3.77500552,1.84072092 3.58385235,1.96234533 L1.9170432,3.02304533 L1.9170432,0.67096512 C1.9170432,0.512150072 1.78830177,0.38340864 1.62948672,0.38340864 L0.28755648,0.38340864 C0.128741432,0.38340864 0,0.512150072 0,0.67096512 L0,5.46357312 C0,5.62238817 0.128741432,5.7511296 0.28755648,5.7511296 L5.84698176,5.7511296 C6.00579681,5.7511296 6.13453824,5.62238817 6.13453824,5.46357312 L6.13453824,2.20494714 C6.13453824,1.97829273 5.88375304,1.84072092 5.69259987,1.96234533 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Solid",
    transform: "translate(-362.000000, -1372.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "industry",
    transform: "translate(362.000000, 1372.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color",
    mask: "url(#mask-2)",
    fill: "#A6A6A6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Purple",
    x: 0,
    y: 0,
    width: 6.13453824,
    height: 6.13453824
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry);
export default __webpack_public_path__ + "static/media/industry.ea54fd50d1b803d517a1e7356388b5fa.svg";
export { ForwardRef as ReactComponent };